import React from "react";
import { Card, CardBody } from "@heroui/react";
import { useTranslation } from "react-i18next";

interface AdminStatsCardsProps {
  totalUsers: number;
  adminCount: number;
  managerCount: number;
  userCount: number;
  totalWorkflows: number;
}

export const AdminStatsCards: React.FC<AdminStatsCardsProps> = ({
  totalUsers,
  adminCount,
  managerCount,
  userCount,
  totalWorkflows,
}) => {
  const { t } = useTranslation();

  const stats = [
    { label: t("Total Users"), value: totalUsers },
    { label: t("Admins"), value: adminCount },
    { label: t("Managers"), value: managerCount },
    { label: t("Users"), value: userCount },
    { label: t("Total Workflows"), value: totalWorkflows },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {stats.map((stat) => (
        <Card key={stat.label} className="border border-default-200">
          <CardBody className="py-3 px-4">
            <p className="text-2xl font-bold text-brand-primary">{stat.value}</p>
            <p className="text-xs text-default-500">{stat.label}</p>
          </CardBody>
        </Card>
      ))}
    </div>
  );
};
